import { useEffect, useMemo, useState } from 'react';
import { Tag } from 'antd';
import { useSearchParams } from 'react-router';
import ProductCollectionService from 'services/product_collection';
import { useWorkSpace } from 'contexts/workspace';

const service = new ProductCollectionService();

const useProductCollection = () => {
  const { workspace } = useWorkSpace();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [filters, setFilters] = useState({});
  const [openModal, setOpenModal] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const websiteUrl = String(workspace?.websiteUrl || '').replace(/\/$/, '');
  const [searchParams] = useSearchParams();

  const mergedParams = useMemo(() => {
    return { ...filters, ...Object.fromEntries(searchParams) };
  }, [filters, searchParams]);

  const loadData = async () => {
    setLoading(true);
    try {
      const result = await service.list(mergedParams);
      setData(result || []);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadData();
  }, [mergedParams]);

  const setFilterValue = (name, value) => {
    setFilters((prevFilters) => ({
      ...prevFilters,
      [name]: value,
    }));
  };

  const onSearch = (value) => {
    setFilterValue('info', value);
  };

  const openCreateModal = () => {
    setSelectedId(null);
    setOpenModal(true);
  };

  const openEditModal = (id) => {
    setSelectedId(id);
    setOpenModal(true);
  };

  const closeModal = () => {
    setOpenModal(false);
    setSelectedId(null);
  };

  const getViewLink = (record) => {
    const path = record?.url_handle ? `/collection/${record.url_handle}` : `/product-collection/${record?.id}`;
    if (websiteUrl) {
      return `${websiteUrl}${path}`;
    }
    return path;
  };

  const renderCollectionType = (condition = {}) => {
    const type = condition.type || 'manual';

    const labelByType = {
      manual: 'Theo sản phẩm',
      tag: 'Theo tag',
      category: 'Theo danh mục',
    };

    const colorByType = {
      manual: 'blue',
      tag: 'green',
      category: 'purple',
    };

    return <Tag color={colorByType[type] || 'default'}>{labelByType[type] || type}</Tag>;
  };

  return {
    data,
    loading,
    filters,
    openModal,
    selectedId,
    loadData,
    onSearch,
    openCreateModal,
    openEditModal,
    closeModal,
    getViewLink,
    renderCollectionType,
  };
};

export default useProductCollection;
